import React, { FC, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useSelector, useDispatch, useI18n, useButton } from '~Hooks';
import LoginModal from '../../../../Tables/Components/LoginModal';
import * as actions from '~actions';
import { BlackButton } from '~Styles';
import { UnderTitle } from '../styles';

const Wrapper = styled.div`
  margin-right: auto;
`;

const Button = styled(BlackButton)`
  height: 56px;
  width: 152px;
  padding: 4px;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const StaffSignIn: FC = () => {
  const dispatch = useDispatch();
  const [showLogin, setShowLogin] = useState(false);
  const staff = useSelector((state) => (state.companyStaff?.staffs.length ? state.staff : false));
  const companyStaff = useSelector((state) => state.companyStaff);
  const { i18n } = useI18n();

  const staffs = companyStaff?.staffs ?? [];
  const staffId = staff ? staff.id : null;
  const staffName = staff ? staff.name : null;

  useEffect(() => {
    if (staffId && showLogin) {
      setShowLogin(false);
    }
  }, [staffId]);

  const logOutButton = useButton({
    onClick: () => dispatch(actions.staffLogout()),
  });

  const logInButton = useButton({
    onClick: () => setShowLogin(true),
  });

  if (!staffs.length) {
    return null;
  }

  return (
    <Wrapper>
      {staffId ? (
        <Button {...logOutButton}>
          {i18n('General.Logout')}
          <UnderTitle>{staffName}</UnderTitle>
        </Button>
      ) : (
        <Button {...logInButton}>{i18n('General.Login')}</Button>
      )}
      {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}
    </Wrapper>
  );
};

export default React.memo(StaffSignIn);
